export const URL = {
    ACCOUNT: {
        LOGIN: '/authenticate/1.1.0',
        EMAIL_SERVICE: '/demo-request',
        CONTACT_SERVICE: '/contact-message',
        LANDING_CONFIG: '/landing-config',
        SUBSCRIPTION_PLAN: '/send-subscription-plan',
    },
}